/**
 * Espelha RetencaoLiquidoUtils (backend): cada retenção percentual arredonda
 * em 2 casas (HALF_UP) antes de compor o líquido — alinhado à NFS-e/PlugNotas.
 */

const roundHalfUp2 = (value) => {
  if (value == null || Number.isNaN(Number(value))) {
    return 0;
  }
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
};

export const calcularRetencaoPercentual = (valorBase, aliquotaPercentual) => {
  if (valorBase == null || aliquotaPercentual == null) {
    return 0;
  }
  return roundHalfUp2((Number(valorBase) * Number(aliquotaPercentual)) / 100);
};

export const calcularRetencao = (valorBase, valorImposto, tipo) => {
  if (valorImposto == null || tipo == null) {
    return 0;
  }
  if (tipo === 'PERCENTUAL') {
    return calcularRetencaoPercentual(valorBase, valorImposto);
  }
  return Number(valorImposto);
};

/**
 * Aplica retenção no total líquido (subtrai do acumulado).
 */
export const aplicarRetencaoNoTotal = (valorBase, tipo, valorImposto, retidoNaFonte, total) => {
  if (!retidoNaFonte || valorImposto == null) {
    return total;
  }
  const tipoEfetivo = tipo || 'PERCENTUAL';
  return Number(total) - calcularRetencao(valorBase, valorImposto, tipoEfetivo);
};

/**
 * Calcula o valor líquido de um serviço a partir do bruto e do fiscal.
 */
export const calcularValorLiquidoComRetencoes = (valorBruto, servicoFiscal = {}) => {
  const {
    tipoIss = 'PERCENTUAL',
    tipoPis = 'PERCENTUAL',
    tipoCofins = 'PERCENTUAL',
    tipoInss = 'PERCENTUAL',
    tipoIrrf = 'PERCENTUAL',
    tipoCsll = 'PERCENTUAL',
    valorIss,
    valorPis,
    valorCofins,
    valorInss,
    valorIrrf,
    valorCsll,
    issRetidoNaFonte,
    pisRetidoNaFonte,
    cofinsRetidoNaFonte,
    inssRetidoNaFonte,
    irrfRetidoNaFonte,
    csllRetidoNaFonte,
  } = servicoFiscal;

  const temRetencao =
    issRetidoNaFonte ||
    pisRetidoNaFonte ||
    cofinsRetidoNaFonte ||
    inssRetidoNaFonte ||
    irrfRetidoNaFonte ||
    csllRetidoNaFonte;

  if (!temRetencao || valorBruto == null) {
    return Number(valorBruto || 0);
  }

  let total = Number(valorBruto);
  total = aplicarRetencaoNoTotal(valorBruto, tipoIss, valorIss, issRetidoNaFonte, total);
  total = aplicarRetencaoNoTotal(valorBruto, tipoPis, valorPis, pisRetidoNaFonte, total);
  total = aplicarRetencaoNoTotal(valorBruto, tipoCofins, valorCofins, cofinsRetidoNaFonte, total);
  total = aplicarRetencaoNoTotal(valorBruto, tipoInss, valorInss, inssRetidoNaFonte, total);
  total = aplicarRetencaoNoTotal(valorBruto, tipoIrrf, valorIrrf, irrfRetidoNaFonte, total);
  total = aplicarRetencaoNoTotal(valorBruto, tipoCsll, valorCsll, csllRetidoNaFonte, total);

  return roundHalfUp2(total);
};
